import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { nanoid } from "nanoid";
import { jsHash } from "../jsHash";
import { cryptoHelpers } from "../cryptoHelpers";
import { slowAES } from "../aes";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    player: false,
    players: [],
    question_id: 0,
    network_error: false,
    team_mode: 0,
    challenge_id: 0,
    njugush_video: false,
    isLoading: false,
    aboutShow: false,
    results: false,
    isOnBreak: false,
    mystery: false,
    checkout: false,
    user_id: "",
    trivia: [],
    playerClickedCard: false,
    categories: [],
    currentCategory: {
      name: "Random",
      id: 9,
    },
    currentGameView: "game-play",
    currentView: "app-intro",
    questions: [],
    isGameOver: false,
    leaderBoard: false,
    isPaused: false,
    round: 0,
    scores: {
      playerOne: {
        history: [],
        total: 0,
        id: "",
        team_id: "",
        team_name: "",
        name: "",
        phone: "",
        results: [],
      },
    },
    solo: true,
    starPower: false,
    username: "",
    matchName: "",
    matchSlug: "",
    isp: false,
    has_game: false,
    has_spin: false,
    has_video: false,
    mystery_boxes: {
      has_mystery_boxes: false,
      boxes: "",
    },
    playersCount: "",
    flushMessages: false,
    finish_loading: true,
    finish_score: 0,
    finish_team_score: 0,
    finish_passed: false,
    finish_next: "",
    finish_failed: "",
    finish_completed_challenge: false,
    finish_belongs_to_challenge: "not",
    puzzleRedirect: null,   
    spinRedirect: null,
  },
  actions: {
    viewGame(context, payload) {
      const api = "https://create.tuni.ke/api/challenge/trivia/view/hidden";
      const qs = require("qs");
      axios({
        method: "post",
        url: api,
        data: qs.stringify({
          trivia_id: payload.trivia_id,
          isp: payload.isp,
          player_id: context.state.scores["playerOne"].id,
        }),
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((response) => {
          console.log("response found here");
          console.log(response.data);
          return response.data;
        })
        .then(
          (data) => {
            if (Object.keys(data.data).length > 0) {
              if (Object.keys(data.data.quiz).length > 0) {
                const sortBy = (sortField, direction = "asc") => {
                  return (a, b) => {
                    if (a[sortField] < b[sortField]) {
                      return direction === "asc" ? -1 : 1;
                    }
                    if (a[sortField] > b[sortField]) {
                      return direction === "asc" ? 1 : -1;
                    }
                    return 0;
                  };
                };
                let input = data.data.quiz;
                let encKey = "2fVwX6oZVM75fl5BKUtrgJMPOXM";
                let inputSplit = input.split(" ");
                let originalSize = parseInt(inputSplit[0]);
                let iv = cryptoHelpers.toNumbers(inputSplit[1]);
                let cipherIn = cryptoHelpers.toNumbers(inputSplit[2]);
                let keyAsNumbers = cryptoHelpers.toNumbers(
                  cryptoHelpers.bin2hex(encKey),
                );
                let decrypted = slowAES.decrypt(
                  cipherIn,
                  slowAES.modeOfOperation.CBC,
                  keyAsNumbers,
                  iv,
                );
                let retVal = cryptoHelpers.hex2bin(
                  cryptoHelpers.toHex(decrypted),
                );
                retVal = cryptoHelpers.decode_utf8(retVal);
                retVal = JSON.parse(retVal);

                let i = 0;
                let imageArray = new Array();
                imageArray = data.data.images;
                let imageObj = new Image();
                for (i = 0; i <= imageArray.length - 1; i++) {
                  imageObj.src = imageArray[i];
                }
                context.commit(
                  "setPlayers",
                  Object.values(data.top_players).sort(
                    sortBy("points", "desc"),
                  ),
                );
                context.commit("flushMessages", false);
                context.commit("team_mode", data.data.team_mode);
                context.commit("has_game", data.data.has_game);
                context.commit("has_spin", data.data.has_spin);
                context.commit("has_video", data.data.has_slide);
                context.commit("has_mystery_boxes", {
                  has_mystery_boxes: data.data.has_mystery_boxes,
                  mystery_boxes: data.data.mystery_boxes,
                });
                context.commit("matchName", data.data.title);
                context.commit("challenge_id", data.data.challenge_id);
                context.commit("playerCount", data.data.players_count);
                context.commit("questions", retVal);
                context.commit("set_trivia", data.data);

            
                if (data.data.has_spin && data.data.spin_wheel_id) {
                  context.commit("setSpinRedirect", {
                  wheelId:    data.data.spin_wheel_id,
                  slug:       data.data.spin_wheel_slug || "",
                  playerName: context.state.scores.playerOne.name,
                  nickname:   context.state.scores.playerOne.name, 
                  phone:      context.state.scores.playerOne.phone,
                  isp:        payload.isp || false,
                  email:      "",
              });
                }

                return true;
              } else {
                context.commit("resetGame", true);
                context.commit("flushMessages", "The match has no questions!");
                return false;
              }
            } else {
              context.commit("resetGame", true);
              context.commit("flushMessages", "The match was not found!");
              return false;
            }
          },
          (error) => {
            context.commit("resetGame", true);
            context.commit(
              "flushMessages",
              "There was an error fetching the trivia!",
            );
            return false;
          },
        );
    },
    notifyNextQuestion(context, payload) {
      console.log("random_pay", payload);
      const api = "https://create.tuni.ke/api/challenge/trivia/question/next";
      const qs = require("qs");
      axios({
        method: "post",
        url: api,
        data: qs.stringify({
          questions: payload,
          team_id: context.state.scores["playerOne"].id,
          trivia_id: payload.trivia_id,
        }),
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      }).then((response) => {});
    },
    registerNewPlayer(context, payload) {
      context.commit("SET_IS_LOADING", true);
      const api = "https://create.tuni.ke/api/challenge/trivia/player/view";
      const qs = require("qs");
      axios({
        method: "post",
        url: api,
        data: qs.stringify({
          player_id: context.state.scores.playerOne.id,
          nickname: payload.name,
          isp: context.state.isp,
        }),
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      }).then((response) => {
        if (response.data.result_code === 1) {
          context.commit(
            "flushMessages",
            "Oops! The nickname you provided has already been taken, try another one!",
          );
          context.commit("SET_IS_LOADING", false);
        } else {
          if (response.data.belongs_to_challenge === true) {
            if (response.data.data.completed === 1) {
              context.commit(
                "flushMessages",
                "You have completed the challenge, Redirecting you to the results page..!",
              );
              context.commit("SET_IS_LOADING", false);
              setTimeout(function() {
                window.location.href = "https://tuni.fun/challenge/51/results";
              }, 3000);
            } else {
              if (response.data.data.completed === 1) {
                context.commit(
                  "flushMessages",
                  "You had completed the trivia, Redirecting you to the next trivia..!",
                );
                context.commit("SET_IS_LOADING", false);
                setTimeout(function() {
                  window.location.href =
                    "https://tuni.fun/challenge/51/results";
                }, 3000);
              } else {
                context.commit("flushMessages", false);
                context.state.scores.playerOne.total = 0;
                context.state.scores.playerOne.history = [];
                context.state.scores.playerOne.results = [];
                context.state.round = response.data.data.last_question;
                context.dispatch("startGame");
                const body = {
                  playerId: context.state.scores.playerOne.id,
                  playerName: payload.name,
                  playerPhone: payload.phone,
                  last_question: response.data.data.last_question,
                  matchSlug: context.state.matchSlug,
                };
                context.commit("REGISTER_PLAYER", body);
                context.commit("SET_IS_LOADING", false);
              }
            }
          } else {
            if (response.data.data.completed === 1) {
              context.commit(
                "flushMessages",
                "You had completed the trivia, Redirecting you to the results page..!",
              );
              context.commit("SET_IS_LOADING", false);
              setTimeout(function() {
                if (context.state.team_mode == 1) {
                  window.location.href =
                    "https://tuni.fun/trivia/" +
                    context.state.matchSlug +
                    "/results/team";
                } else {
                  window.location.href =
                    "https://tuni.fun/trivia/" +
                    context.state.matchSlug +
                    "/results";
                }
              }, 3000);
            } else {
              context.commit("flushMessages", false);
              context.state.scores.playerOne.total = 0;
              context.state.scores.playerOne.history = [];
              context.state.scores.playerOne.results = [];
              context.state.round = response.data.data.last_question;
              context.dispatch("startGame");
              const body = {
                playerId: context.state.scores.playerOne.id,
                playerName: payload.name,
                playerPhone: payload.phone,
                last_question: response.data.data.last_question,
                matchSlug: context.state.matchSlug,
              };
              context.commit("REGISTER_PLAYER", body);
              context.commit("SET_IS_LOADING", false);
            }
          }
        }
        return response.data.data;
      });
    },
    starPower(context) {
      context.commit("starPower");
      let vm = context;
      setTimeout(() => {
        vm.state.starPower = false;
      }, 1600);
    },
    startGame(context) {
      context.state.currentView = "app-loader";
      context.commit("startGame");
    },
  },
  // ========== GETTERS ============
  getters: {
    playerCount(state) {
      return state.players.length;
    },
    mode: (state) => {
      return state.solo;
    },
    round: (state) => {
      return state.round;
    },
    turn: (state) => {
      let check = state.round % 2;
      if (check === 0 || state.round === 0) {
        return "playerOne";
      } else {
        return "playerTwo";
      }
    },
  },
  // ============ MUTATIONS ===============
  mutations: {
    FINISH_THE_GAME(state, data) {
      state.finish_loading = data.loading;
      state.finish_score = data.score;
      state.finish_team_score = data.team_score;
      state.finish_passed = data.passed;
      state.finish_next = data.next;
      state.finish_failed = data.failed;
      state.finish_completed_challenge = data.completed_challenge;
      state.finish_belongs_to_challenge = data.belongs_to_challenge;
    },
    REGISTER_PLAYER(state, player) {
      if (player) {
        state.player = {
          name: player.playerName,
          phone: player.playerPhone,
          round: player.last_question,
          id: player.playerId,
        };
      } else {
        state.player = player;
      }
    },
    SET_IS_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_IS_GAME_OVER(state, status) {
      state.isGameOver = !status;
      state.leaderBoard = status;
      state.currentView = "leader-board";
    },
    setCurrentView: (state, payload) => {
      state.currentView = payload;
    },
    setResults: (state, payload) => {
      state.results = payload;
    },
    setUserId: (state, payload) => {
      state.user_id = payload;
    },
    setCheckout: (state, payload) => {
      state.checkout = payload;
      state.leaderBoard = false;
    },
    setPlayers: (state, payload) => {
      state.players = payload;
    },
    setCurrentPlayer: (state, payload) => {
      state.scores.playerOne.id        = payload.id;
      state.scores.playerOne.team_id   = payload.team_id;
      state.scores.playerOne.team_name = payload.team_name;
      state.scores.playerOne.name      = payload.name;
      state.scores.playerOne.phone     = payload.phone;
    },
    addScore: (state, payload) => {
      state.scores["playerOne"].total += payload;
    },
    matchSlug: (state, payload) => {
      state.matchSlug = payload;
    },
    isp: (state, payload) => {
      state.isp = payload;
    },
    set_trivia: (state, payload) => {
      state.trivia = payload;
    },
    has_game: (state, payload) => {
      state.has_game = payload;
    },
    has_spin: (state, payload) => {
      state.has_spin = payload;
    },
    has_video: (state, payload) => {
      state.has_video = payload;
    },
    has_mystery_boxes: (state, payload) => {
      state.mystery_boxes.has_mystery_boxes = payload.has_mystery_boxes;
      state.mystery_boxes.boxes = payload.mystery_boxes;
    },
    matchName: (state, payload) => {
      state.matchName = payload;
    },
    challenge_id: (state, payload) => {
      state.challenge_id = payload;
    },
    njugush_video: (state, payload) => {
      state.njugush_video = payload;
    },
    questions: (state, payload) => {
      state.questions = payload;
    },
    playerCount: (state, payload) => {
      state.playersCount = payload;
    },
    playerClickedCard: (state, payload) => {
      state.playerClickedCard = payload;
    },
    aboutToggle: (state) => {
      state.aboutShow = !state.aboutShow;
    },
    isGameOver: (state) => {
      if (state.round === state.questions.length - 1) {
        setTimeout(function() {
          if (state.challenge_id == 37) {
            state.isGameOver = true;
          } else {
            state.isGameOver = false;
          }
          if (state.challenge_id == 46) {
            state.isGameOver = true;
          } else {
            state.isGameOver = false;
          }
          state.leaderBoard = true;
          state.currentView = "leader-board";
        }, 1500);
      }
    },
    setIsOnBreak: (state, payload = false) => {
      state.isOnBreak = payload;
    },
    setMystery: (state, payload = false) => {
      state.mystery = payload;
    },
    incrementRound: (state) => {
      state.round += 1;
    },
    newGame: (state) => {
      state.leaderBoard = false;
      state.currentCategory.name = "Random";
      state.currentCategory.id = 9;
      state.playerClickedCard = false;
      state.currentView = "app-intro";
      state.currentGameView = "game-play";
      state.solo = true;
      state.flushMessages = false;
    },
    pauseGame: (state, payload) => {
      if (payload === "pause") {
        state.isPaused = true;
      } else {
        state.isPaused = false;
      }
    },
    resetGame: (state, payload) => {
      state.leaderBoard = false;
      state.isGameOver = false;
      state.isPaused = false;
      state.questions = [];
      state.round = 0;
      state.isLoading = payload;
      state.player = false;
      state.playerClickedCard = false;
      state.scores.playerOne.total = 0;
      state.scores.playerOne.history = [];
      state.scores.playerOne.results = [];
      state.flushMessages = false;
    },
    score: (state, payload) => {
      let context = this;
      let data;
      state.question_id = payload.question_id;
      if (payload.true) {
        state.scores["playerOne"].history.push({
          correct: true,
          incorrect: false,
        });
        state.scores["playerOne"].total = payload.score;
        data = {
          question_id: payload.question_id,
          trivia_id: state.matchSlug,
          player_id: state.scores["playerOne"].id,
          answer: payload.answer,
          isp: state.isp,
          current_points: payload.score,
          points: payload.score,
          milliseconds_remaining: payload.milliseconds_remaining,
          milliseconds_taken: payload.milliseconds_taken,
          points_hybrid: payload.points_hybrid,
          answer_time: payload.time,
          last_question: payload.last_question,
          channel: "web",
        };
        state.scores["playerOne"].results.push({
          _key: nanoid(),
          _id: state.player.id,
          score: payload.score,
          name: state.player.name,
          isCorrect: true,
        });
      } else {
        state.scores["playerOne"].history.push({
          correct: false,
          incorrect: true,
        });
        data = {
          question_id: payload.question_id,
          trivia_id: state.matchSlug,
          player_id: state.scores["playerOne"].id,
          user_id: state.user_id,
          answer: payload.answer,
          isp: state.isp,
          current_points: payload.score,
          points: payload.score,
          milliseconds_remaining: payload.milliseconds_remaining,
          milliseconds_taken: payload.milliseconds_taken,
          points_hybrid: payload.points_hybrid,
          answer_time: payload.time,
          last_question: payload.last_question,
          channel: "web",
        };
        state.scores["playerOne"].results.push({
          _key: nanoid(),
          _id: state.player.id,
          score: payload.score,
          name: state.player.name,
          isCorrect: false,
        });
      }
      const api =
        "https://create.tuni.ke/api/challenge/trivia/question/answer/create";
      const qs = require("qs");
      axios({
        method: "post",
        url: api,
        data: qs.stringify(data),
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((response) => {
          const sortBy = (sortField, direction = "asc") => {
            return (a, b) => {
              if (a[sortField] < b[sortField]) {
                return direction === "asc" ? -1 : 1;
              }
              if (a[sortField] > b[sortField]) {
                return direction === "asc" ? 1 : -1;
              }
              return 0;
            };
          };
          store.commit(
            "setPlayers",
            Object.values(response.data.data).sort(sortBy("points", "desc")),
          );
          return response.data.data;
        })
        .catch(function(error) {
          if (!error.response) {
            Vue.$confirm({
              title: "No Internet Connection",
              message: "Check your network settings and try again.",
              button: { yes: "OK" },
              callback: (confirm) => {
                location.reload();
              },
            });
          }
        });
    },
    selectMode: (state, payload) => {
      payload === true ? (state.solo = true) : (state.solo = false);
    },
    setCurrentCategory: (state, payload) => {
      state.currentCategory.name = payload.name;
      state.currentCategory.id = payload.id;
    },
    setUsername: (state, payload) => {
      state.username = payload;
    },
    starPower: (state) => {
      state.starPower = true;
    },
    flushMessages: (state, payload) => {
      state.flushMessages = payload;
      state.currentView = "app-intro";
    },
    team_mode: (state, payload) => {
      state.team_mode = payload;
    },
    startGame: (state) => {
      state.isGameOver = true;
      state.questions.forEach((el) => {
        el.choices = el.incorrect_answers.reduce((acc, item, index) => {
          if (el.type == "poll") {
            acc.push({
              _key: index,
              id: el.id,
              text: item,
              votes: Math.floor(Math.random() * 100),
              answer: false,
              classes: { incorrect: true },
            });
          } else {
            acc.push({
              _key: index,
              id: el.id,
              text: item,
              answer: false,
              classes: { incorrect: true },
            });
          }
          return acc;
        }, []);
        if (el.type == "poll") {
          el.choices.push({
            _key: 4,
            id: el.id,
            text: el.correct_answer,
            answer: false,
            votes: Math.floor(Math.random() * 100),
            classes: { incorrect: true },
          });
        } else {
          el.choices.push({
            _key: 4,
            id: el.id,
            text: el.correct_answer,
            answer: true,
            classes: { correct: true },
          });
        }
        let i = el.choices.length, temp, rand;
        while (0 !== i) {
          rand = Math.floor(Math.random() * i);
          i -= 1;
          temp = el.choices[i];
          el.choices[i] = el.choices[rand];
          el.choices[rand] = temp;
        }
      });
      state.playerClickedCard = false;
      state.currentView = "app-game-board";
      state.currentGameView = "game-play";
    },
    styleButtons: (state, payload) => {
      state.questions[state.round].choices.forEach((el) => {
        if (el.answer) {
          if (el.text === payload) {
            el.classes = { correct: true, incorrect: false, selected: true };
          } else {
            el.classes = { correct: true, incorrect: false, selected: false };
          }
        } else {
          if (el.text === payload) {
            el.classes = { incorrect: true, correct: false, selected: true };
          } else {
            el.classes = { incorrect: true, correct: false, selected: false };
          }
        }
      });
    },


    setPuzzleRedirect(state, payload) {
      state.puzzleRedirect = payload;
    },

    setSpinRedirect(state, payload) {
      state.spinRedirect = payload;
    },
  },
});